import { NestableListIndentSize } from '.';
import { DEFAULT_INDENT_SIZE, depthThresholds, indentSizes } from './constants';

const getIsCorrectIndentSizeValue = (
  indentSize: string,
): indentSize is NestableListIndentSize => {
  return indentSizes.includes(indentSize as NestableListIndentSize);
};

export const normalizeIndentSize = (
  indentSize: string,
): NestableListIndentSize => {
  return getIsCorrectIndentSizeValue(indentSize)
    ? indentSize
    : DEFAULT_INDENT_SIZE;
};

export const getDepthThreshold = (indentSize: NestableListIndentSize) => {
  return depthThresholds[indentSize];
};
